import { useGif } from "@portal/providers/GifProvider";
import { FC } from "react";
import KLIPYWatermark from "../../../assets/logos/KLIPY-watermark.svg";

export const GifDisplay: FC<{ id: string }> = ({ id }) => {
	const { data, isLoading, error } = useGif(id);

	if (isLoading) {
		return <div className="animate-pulse bg-gray-200 h-32 w-full rounded" />;
	}
	if (error || !data) {
		return (
			<div className="max-w-[360px] p-3 flex items-center justify-center border border-gray-200 rounded-md select-none">
				There was an error loading this GIF
			</div>
		);
	}

	return (
		<div className="flex flex-col max-w-[360px] object-contain relative select-none">
			<img
				id={data.id}
				src={data.url}
				alt={data.title}
				className="inline-block"
				loading="lazy"
				decoding="async"
			/>
			<img src={KLIPYWatermark} className="absolute bottom-2 left-2 max-h-[15px] opacity-60" />
		</div>
	);
};
